<template>
  <v-container fluid :class="`account-overivew-wrapper ${$vuetify.breakpoint.smAndUp?'':'pl-5'}`">
    <v-row class="mt-6">
      <v-col cols="12" sm="6" md="6">
        <v-card
          elevation="2"
          outlined
          class="py-1 px-4"
        >
          <v-card-title class="pb-0">Important Contacts</v-card-title>
          <v-card-text class="pb-0">
            <div 
              class="overview-contact-section py-8" 
              v-for="contact in contacts" 
              :key="contact.title"
            >
              <h3 class="text--primary text-capitalize">
                {{contact.title}}
              </h3>
              <div class="my-2">
                {{contact.description}}
              </div>
              <v-btn 
                outlined
                v-track="contact.uniqueId"
                :href="`${contact.button.link}?Subject=[#${account.id}] - ${contact.subject}`"
              >
                {{contact.button.text}}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>

      </v-col>
      <v-col cols="12" sm="6" md="6" >
        <v-card
          elevation="2"
          outlined
          class="py-1 px-4"
        >
          <v-card-title >Common Actions</v-card-title>
          <v-card-text>
            <div 
              class="overview-common-actions pt-1" 
              v-for="action in commonActions" 
              :key="action.text"
            >
              <a class="text-decoration-none" :href="`${action.link}`" v-track="action.uniqueId" :target="action.target" v-if="action.target">
                <v-icon class="accent--text">{{action.icon}} </v-icon> 
                <span class="action-link-text ml-1">{{action.text}} </span>
              </a>
              <router-link class="text-decoration-none" :to="action.link" v-track="action.uniqueId" v-if="!action.target">
                <v-icon class="accent--text">{{action.icon}} </v-icon>
                <span class="action-link-text ml-1" >{{action.text}} </span>
              </router-link>
            </div>
            
          </v-card-text>
        </v-card>
        <br/>
        <v-card
          elevation="2"
          outlined
          class="py-1 px-4 pb-3"
        >
          <v-card-title >Plan Details</v-card-title>
          <v-card-text>
            <div v-if="hasMarketingAccess" class="py-8 mb-3">
              <div class="d-flex align-center">
                <v-img
                  src="@core/assets/images/logo_mmc.svg"
                  max-width="18"
                  class="mr-3"
                />
                <h3 class="text--primary subtitle-1">Marketing Cloud</h3>
              </div>
              <a href="" class="ml-8 pt-2 pl-4 text-decoration-none text-capitalize">{{this.marketingCloudPackageType}}</a>
            </div>
            <v-divider v-if="hasServiceAccess && hasMarketingAccess" class="pb-8 mt-2" />
            <div v-if="hasServiceAccess" class="py-8">
              <div class="d-flex align-center">
                <v-img
                  src="@core/assets/images/logo_msc.svg"
                  max-width="18"
                  class="mr-3"
                />
                <h3 class="text--primary subtitle-1">Service Cloud</h3>
              </div>
              <a href="" class="ml-8 pt-2 pl-4 text-decoration-none text-capitalize">{{ this.serviceCloudPackageType }}</a>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" >
        <v-card
          elevation="2"
          outlined
          class="py-6 px-6"
        >
          <v-card-text>
            <div>
              <span class="font-weight-large text--primary">Want to enhance your experience? </span>
              <span class="ml-2"> Explore Maropost for upgrades, services and add-ons.</span>
                
                <a 
                  :href="exploreMaropost" 
                  v-track="'expore-maropost-link'"
                  target="_blank"
                  class="float-right mt-n2 v-btn theme--dark v-size--default">
                  Explore Maropost
                </a>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" >
        <v-card
          elevation="2"
          outlined
          class="py-1 px-4"
        >
          <v-card-title >Account &amp; Billing Help</v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" class="pt-4" sm="4" md="4" v-for="question in faqs" :key="question.title">
                <a class="font-weight-medium" :href="`${question.link}`"  v-track="question.uniqueId">
                  {{question.title}}
                </a>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import constants from "@core/config/constants";
import { replaceUnderscore } from "@core/config/utils.js";
import isEmpty from "lodash/isEmpty";
const { OFFICIAL_EMAILS, PRODUCT_IDENTFIERS } = constants;
export default {
  name: 'AccountOverview',
  data () {
    return {
      commonActions:[
        {
          id: 'change-company-info-link',
          icon: 'mdi-equalizer',
          uniqueId: 'change_company_info',
          text: 'Change Company Name or Address',
          link: {
            name:'Account_settings_account'
          },
        },
        {
          id: 'knowledge-base-link',
          icon: 'mdi-help',
          uniqueId: 'knowledge_base',
          text: 'Explore Maropost Galaxy Knowledge Base',
          link: 'https://galaxy.maropost.com/s/',
          target: '_blank'
        }
      ],
      exploreMaropost: 'https://www.maropost.com/platform/plans/'
    }
  },
  computed:{
    ...mapGetters({
      user:'auth/userdata',
      account:'auth/account',
      currentAccount: "auth/account.current",
      packageFeatures: 'auth/packageFeatures',
      subscriptionDetails: "auth/serviceCloudPackage"
    }),
    hasMarketingAccess(){
      return this.currentAccount.enable_marketing;
    },
    hasServiceAccess(){
      return this.currentAccount.enable_service
    },
    serviceCloudPackageType() {
      const subscriptionDetails = this.subscriptionDetails && this.subscriptionDetails.package_type
      return subscriptionDetails ? `Service ${replaceUnderscore(subscriptionDetails)}`: 'Service';
    },
    marketingCloudPackageType(){
      const packageType = this.packageFeatures && this.packageFeatures.account_setting && this.packageFeatures.account_setting.package_type;
      return packageType ? `Marketing ${replaceUnderscore(packageType)}` : 'Marketing';
    },
    contacts(){
      return [
        {
          title: 'Support',
          uniqueId: 'support',
          description: 'We\'re here to help with any questions you have about the platform.',
          button:{
            text:'Email Support',
            link:`mailto:${OFFICIAL_EMAILS.SUPPORT_EMAIL}`
          },
          subject:'Help support'
        },
        {
          title: 'Subscription & Account Changes',
          uniqueId: 'account_changes',
          description: 'We\'re here to help with any changes you want to make to your account.',
          button:{
            text: 'EMAIL SUBSCRIPTIONS',
            link:`mailto:${OFFICIAL_EMAILS.ACCOUNT_CHANGES_EMAIL}`
          },
          subject: 'Subscription and Account Changes'
        },
        {
          title: 'Billing',
          uniqueId: 'billing',
          description: 'Contact us to get information about your billing.',
          button:{
            text: 'Email Billing',
            link:`mailto:${OFFICIAL_EMAILS.BILLING_EMAIL}`
          },
          subject: 'Billing Help'
        }
      ]
    },
    faqs(){
      return [
        {
          uniqueId: 'update_payment_method',
          title: 'How do I update my payment method?',
          link:`mailto:${OFFICIAL_EMAILS.ACCOUNT_CHANGES_EMAIL}?Subject=[#${this.account.id}] - I want to update my payment method`
        },
        {
          uniqueId: 'last_invoice_link',
          title: 'How can I see my last invoice?',
          link: `mailto:${OFFICIAL_EMAILS.BILLING_EMAIL}?Subject=[#${this.account.id}] - I want to see my last invoice`
        },
        {
          uniqueId: 'billing_cycle_link',
          title: 'What is my billing cycle?',
          link: `mailto:${OFFICIAL_EMAILS.BILLING_EMAIL}?Subject=[#${this.account.id}] - I want to know what my billing cycle is`
        },
        {
          uniqueId: 'cancel_my_account',
          title: 'How do I cancel my account?',
          link: `mailto:${OFFICIAL_EMAILS.ACCOUNT_CHANGES_EMAIL}?Subject=[#${this.account.id}] - I want to cancel my account`
        },
        {
          uniqueId: 'next_invoice',
          title: 'When is my next invoice arriving?',
          link: `mailto:${OFFICIAL_EMAILS.BILLING_EMAIL}?Subject=[#${this.account.id}] - When is my next invoice arriving?`
        }
      ]
    },
    currentCustomerId() {
      let customerId = this.account.current.customer_id;

      if (!customerId && !isEmpty(this.account.list)) {
        const idx = this.account.list.findIndex(
          account => account.id == this.account.id
        );

        if (idx !== -1) customerId = this.account.list[idx].customer_id;
      }

      return customerId;
    },
  },
  methods: {
    ...mapActions({
      getServiceCloudPackage: "auth/getServiceCloudPackage"
    }),
    async getSubscriptionDetails(){
      const params = { product_eq: PRODUCT_IDENTFIERS.msc.id };

      await this.getServiceCloudPackage({
        customerId: this.currentCustomerId,
        params
      });
    }
  },
  mounted(){
    this.getSubscriptionDetails()
  }
}
</script>
<style scoped>
.overview-contact-section{
  border-bottom: 1px solid #eee;
}
.overview-contact-section:last-of-type {
  border-bottom: none;
}
.action-link-text{
  vertical-align: bottom;
  text-decoration: underline !important;
}
/* 
* Following styles would be removed on user settings completion
*/
.v-application .accent--text {
  color: #006baf !important;
  caret-color: #006baf !important;
}
.font-weight-large {
  font-weight: 600 !important;
}
.subtitle-1 {
  font-weight: bold;
}
.v-btn {
  font-weight: 700;
}
.theme--dark {
  background-color: #212121;
}
</style>